import { createTheme } from '@mui/material/styles';

let CustomTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#143B6B',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#8ca1bb',
      main: '#4D81BA',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#101e2f',
    },
    success: {
      main: '#2e7d32',
    },
    action: {
      disabled: 'rgba(0, 0, 0, 0.26)',
    },
    warning: {
      main: '#ff9800',
    },
    error: {
      main: '#d32f2f',
    },
  },
});

CustomTheme = createTheme(CustomTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: '0px',
          padding: '0px',
          background: '#fbfcfd',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 'normal',
          overflowX: 'hidden',
          backgroundColor: '#fbfcfd',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          '&.MuiTableCell-head': {
            fontWeight: 600,
            fontSize: '12px',
            color: 'black',
            textTransform: 'uppercase',
          },
        },
      },
    },
  },
});

export default CustomTheme;
